import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { AppState } from '../../interfaces/app-state.interface';

@Directive({
  selector: '[ifCblc]',
})
export class IfCblcDirective {

    // Cblc do usuário
    public cblc: string;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        store: Store<AppState>,
    ) {

        // Definir CBLC do cliente logado
        store
            .select((state) => state.authentication)
            .pipe(
                filter(({ currentUser }) => currentUser && currentUser.cblc),
                take(1),
            )
            .subscribe(({ currentUser }) => this.cblc = currentUser.cblc);

    }

    /**
     * Diretiva para definir a visibilidade de determinado elemento no DOM com base em digitos finais de CBLC
     *
     * @param  {number[]} cblcFinalNumbers
     */
    @Input()
    public set ifCblc(cblcFinalNumbers: number[]) {

        if (this.cblc && Array.isArray(cblcFinalNumbers) && cblcFinalNumbers.includes(this.lastCblcDigit)) {

            this.viewContainer.createEmbeddedView(this.templateRef);

        } else {

            this.viewContainer.clear();

        }

    }

    /**
     * Retorna o ultimo digito do CBLC de um cliente
     *
     */
    private get lastCblcDigit() {
        return +this.cblc.slice(-1);
    }

}
